export * from './resultList.service';